import { createSelector } from 'reselect'
import isFreeSampleVariantUtil from 'modules/variant/utils/is-free-sample'
import getCurrentVariantProductSelect from 'modules/product/redux/selectors/get-current-variant'

const isCurrentVariantAFreeSampleProductSelect = createSelector(
  getCurrentVariantProductSelect,
  /**
   * @param {ProductVariantCollection} currentVariant
   */
  (currentVariant) => isFreeSampleVariantUtil(currentVariant)
)

export default isCurrentVariantAFreeSampleProductSelect
